import { render } from "./warn.vue?vue&type=template&id=197ccc12&scoped=true"
import script from "./warn.vue?vue&type=script&lang=js"
export * from "./warn.vue?vue&type=script&lang=js"

import "./warn.vue?vue&type=style&index=0&id=197ccc12&lang=scss&scoped=true"
import "./warn.vue?vue&type=style&index=1&id=197ccc12&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197ccc12"]])

export default __exports__